'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AppManager = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isFunction = require('d2-utilizr/lib/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isNumeric = require('d2-utilizr/lib/isNumeric');

var _isNumeric2 = _interopRequireDefault(_isNumeric);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _stringReplaceAll = require('d2-utilizr/lib/stringReplaceAll');

var _stringReplaceAll2 = _interopRequireDefault(_stringReplaceAll);

var _arrayClean = require('d2-utilizr/lib/arrayClean');

var _arrayClean2 = _interopRequireDefault(_arrayClean);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _arraySort = require('d2-utilizr/lib/arraySort');

var _arraySort2 = _interopRequireDefault(_arraySort);

var _arrayTo = require('d2-utilizr/lib/arrayTo');

var _arrayTo2 = _interopRequireDefault(_arrayTo);

var _arrayUnique = require('d2-utilizr/lib/arrayUnique');

var _arrayUnique2 = _interopRequireDefault(_arrayUnique);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var AppManager = exports.AppManager = undefined;

exports.AppManager = AppManager = function AppManager(refs) {
    var t = this;

    t.refs = (0, _isObject2.default)(refs) ? refs : {};

    // constants
    t.defaultUiLocale = 'en';
    t.defaultDisplayProperty = 'displayName';
    t.defaultAnalyticsDisplayProperty = 'name';
    t.defaultIndexedDb = 'dhis2';
    t.rootNodeId = 'root';

    t.defaultRequestHeaders = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    t.defaultAnalysisFields = ['*', 'interpretations[*,user[id,displayName],likedBy[id,displayName],comments[id,lastUpdated,text,user[id,displayName]]]', 'columns[dimension,filter,legendSet[id],items[dimensionItem~rename(id),dimensionItemType,$]]', 'rows[dimension,filter,legendSet[id],items[dimensionItem~rename(id),dimensionItemType,$]]', 'filters[dimension,filter,legendSet[id],items[dimensionItem~rename(id),dimensionItemType,$]]', 'access', 'userGroupAccesses', 'publicAccess', 'displayDescription', 'user[displayName]', '!href', '!rewindRelativePeriods', '!userOrganisationUnit', '!userOrganisationUnitChildren', '!userOrganisationUnitGrandChildren', '!externalAccess', '!relativePeriods', '!columnDimensions', '!rowDimensions', '!filterDimensions', '!organisationUnitGroups', '!itemOrganisationUnitGroups', '!indicators', '!dataElements', '!dataElementOperands', '!dataElementGroups', '!dataSets', '!periods', '!organisationUnitLevels', '!organisationUnits'];

    t.displayPropertyMap = {
        'name': 'displayName',
        'displayName': 'displayName',
        'shortName': 'displayShortName',
        'displayShortName': 'displayShortName'
    };

    t.userIdDestroyCacheKeys = ['USER_ORGUNIT', 'USER_ORGUNIT_CHILDREN', 'USER_ORGUNIT_GRANDCHILDREN'];

    t.ignoreResponseHeaders = ['dy', 'value', 'psi', 'ps', 'eventdate', 'longitude', 'latitude', 'ouname', 'oucode'];

    // uninitialized
    t.appName;
    t.sessionName;
    t.manifest;
    t.env;
    t.systemInfo;
    t.systemSettings;
    t.userAccount;
    t.calendar;
    t.periodGenerator;
    t.viewUnapprovedData;

    t.rootNodes = [];
    t.organisationUnitLevels = [];
    t.dimensions = [];
    t.categoryOptionGroupSets = [];
    t.dimensions = [];
    t.legendSets = [];
    t.dataApprovalLevels = [];
    t.userFavorites = [];

    // transient
    t.path;
    t.dateFormat;
    t.relativePeriod;
    t.uiLocale;
    t.displayProperty;
    t.displayPropertyUrl;
    t.analyticsDisplayProperty;
    t.analysisFields;
    t.legendSetMap;

    // optional
    t.manifestVersion;
    t.apiVersion;

    // fns
    t.getUrlParam = function (s) {
        var output = '';
        var href = window.location.href;
        if (href.indexOf('?') > -1) {
            var query = href.substr(href.indexOf('?') + 1);
            var query = query.split('&');
            for (var i = 0; i < query.length; i++) {
                if (query[i].indexOf('=') > -1) {
                    var a = query[i].split('=');
                    if (a[0].toLowerCase() === s) {
                        output = a[1];
                        break;
                    }
                }
            }
        }
        return unescape(output);
    };

    // event handler array
    t.getEventHandlerArray = function () {
        var a = [];

        a.run = function (params) {
            a.forEach(function (fn) {
                fn(params.cmp, params.width, params.height, params.eOpts);
            });
        };

        return a;
    };
};

AppManager.prototype.init = function (callbackFn) {
    var t = this;

    // manifest
    var manifestReq = function manifestReq() {
        new t.refs.api.Request(t.refs, {
            baseUrl: 'manifest.webapp',
            type: 'json',
            success: function success(response) {
                t.manifest = response;
                t.env = process.env.NODE_ENV;
                t.setAuth();
                t.logVersion();

                systemInfoReq();
            }
        }).run();
    };

    // system info
    var systemInfoReq = function systemInfoReq() {
        new t.refs.api.Request(t.refs, {
            baseUrl: t.getApiPath() + '/system/info.json',
            type: 'json',
            success: function success(response) {
                t.systemInfo = response;
                t.path = response.contextPath;

                systemSettingsReq();
            }
        }).run();
    };

    // system settings
    var systemSettingsReq = function systemSettingsReq() {
        new t.refs.api.Request(t.refs, {
            baseUrl: t.getApiPath() + '/systemSettings.json',
            type: 'json',
            params: ['key=keyCalendar', 'key=keyDateFormat', 'key=keyAnalysisRelativePeriod', 'key=keyHideUnapprovedDataInAnalytics', 'key=keyAnalysisDigitGroupSeparator', 'key=keyIgnoreAnalyticsApprovalYearThreshold'],
            success: function success(response) {
                t.systemSettings = response;

                userAccountReq();
            }
        }).run();
    };

    // user account
    var userAccountReq = function userAccountReq() {
        new t.refs.api.Request(t.refs, {
            baseUrl: t.getApiPath() + '/me.json',
            type: 'json',
            params: ['fields=id,firstName,surname,userCredentials[username],settings'],
            success: function success(response) {
                t.userAccount = response;

                var calendarManager = t.refs.calendarManager;

                calendarManager.setBaseUrl(t.getPath());
                calendarManager.setDateFormat(t.getDateFormat());
                calendarManager.init(t.systemSettings.keyCalendar);

                // allow for other code to be executed after all the init stuff is done
                if (callbackFn) {
                    callbackFn();
                }
            }
        }).run();
    };

    manifestReq();
};

AppManager.prototype.logVersion = function () {
    if (console && this.manifest && this.manifest.version) {
        var version = 'v' + this.manifest.version;
        var name = this.manifest.name || null;

        var msg = (0, _arrayClean2.default)([name, version]).join(' ');
        var fn = console.info || console.log;

        fn.call(console, msg);
    }
};

AppManager.prototype.getPath = function () {
    var dhis = this.manifest ? this.manifest.activities.dhis : {};

    return this.path ? this.path : this.env === 'production' ? dhis.href : dhis.devHref || dhis.href;
};

AppManager.prototype.getManifestFullVersionNumber = function () {
    var t = this;

    return t.manifest && (0, _isNumeric2.default)(parseInt(t.manifest.version)) ? parseInt(t.manifest.version) : t.manifestVersion || undefined;
};

AppManager.prototype.getApiVersion = function () {
    return this.apiVersion;
};

AppManager.prototype.getDateFormat = function () {
    return this.dateFormat ? this.dateFormat : this.dateFormat = (0, _isString2.default)(this.systemSettings.keyDateFormat) ? this.systemSettings.keyDateFormat.toLowerCase() : 'yyyy-mm-dd';
};

AppManager.prototype.getRelativePeriod = function () {
    return this.relativePeriod ? this.relativePeriod : this.relativePeriod = this.systemSettings.keyAnalysisRelativePeriod || 'LAST_12_MONTHS';
};

AppManager.prototype.getUiLocale = function () {
    return this.uiLocale ? this.uiLocale : this.uiLocale = this.userAccount.settings.keyUiLocale || this.defaultUiLocale;
};

AppManager.prototype.getDisplayProperty = function () {
    if (this.displayProperty) {
        return this.displayProperty;
    }

    var keyAnalysisDisplayProperty = this.userAccount && this.userAccount.settings ? this.userAccount.settings.keyAnalysisDisplayProperty : null;

    return this.displayProperty = this.displayPropertyMap[keyAnalysisDisplayProperty || this.defaultDisplayProperty];
};

AppManager.prototype.getAnalyticsDisplayProperty = function () {
    if (this.analyticsDisplayProperty) {
        return this.analyticsDisplayProperty;
    }

    var keyAnalysisDisplayProperty = this.userAccount && this.userAccount.settings ? this.userAccount.settings.keyAnalysisDisplayProperty : null;

    return this.analyticsDisplayProperty = (keyAnalysisDisplayProperty || this.defaultAnalyticsDisplayProperty).toUpperCase();
};

AppManager.prototype.getRootNodes = function () {
    return this.rootNodes;
};

AppManager.prototype.addRootNodes = function (param) {
    var t = this,
        nodes = (0, _arrayFrom2.default)(param);

    nodes.forEach(function (node) {
        node.expanded = true;
        node.path = '/' + t.rootId + '/' + node.id;
    });

    t.rootNodes = (0, _arrayClean2.default)(t.rootNodes.concat(nodes));
};

AppManager.prototype.addOrganisationUnitLevels = function (param) {
    this.organisationUnitLevels = (0, _arrayClean2.default)(this.organisationUnitLevels.concat((0, _arrayFrom2.default)(param)));

    (0, _arraySort2.default)(this.organisationUnitLevels, 'ASC', 'level');
};

AppManager.prototype.addLegendSets = function (param) {
    this.legendSets = (0, _arrayClean2.default)(this.legendSets.concat((0, _arrayFrom2.default)(param)));

    (0, _arraySort2.default)(this.legendSets, 'ASC', 'name');
};

AppManager.prototype.getLegendSetById = function (id) {
    var t = this;

    if (t.legendSetMap) {
        return t.legendSetMap[id];
    }

    t.legendSetMap = {};

    t.legendSets.forEach(function (set) {
        t.legendSetMap[set.id] = set;
    });

    return t.legendSetMap[id];
};

AppManager.prototype.addDimensions = function (param) {
    this.dimensions = (0, _arrayClean2.default)(this.dimensions.concat((0, _arrayFrom2.default)(param)));

    (0, _arraySort2.default)(this.dimensions, 'ASC', 'name');
};

AppManager.prototype.addCategoryOptionGroupSets = function (param) {
    this.categoryOptionGroupSets = (0, _arrayClean2.default)(this.categoryOptionGroupSets.concat((0, _arrayFrom2.default)(param)));

    (0, _arraySort2.default)(this.categoryOptionGroupSets, 'ASC', 'name');
};

AppManager.prototype.addDataApprovalLevels = function (param) {
    this.dataApprovalLevels = (0, _arrayClean2.default)(this.dataApprovalLevels.concat((0, _arrayFrom2.default)(param)));

    (0, _arraySort2.default)(this.dataApprovalLevels, 'ASC', 'level');
};

AppManager.prototype.addIgnoreResponseHeaders = function (headers, append) {
    var t = this;

    t.ignoreResponseHeaders = (0, _arrayUnique2.default)([].concat(_toConsumableArray(append ? t.ignoreResponseHeaders : []), _toConsumableArray(headers)));
};

AppManager.prototype.setAuth = function (binary, ascii) {
    var J = 'jQuery' in window ? window['jQuery'] : undefined;
    var E = 'Ext' in window ? window['Ext'] : undefined;
    var headers;
    var auth;

    if (binary || ascii) {
        headers = {
            Authorization: ascii ? ascii : 'Basic ' + btoa(binary)
        };
    } else if (this.env !== 'production' && this.manifest && (0, _isString2.default)(this.manifest.activities.dhis.auth)) {
        headers = {
            Authorization: 'Basic ' + btoa(this.manifest.activities.dhis.auth)
        };
    }

    if (headers) {
        if (J) {
            J.ajaxSetup({
                headers: headers
            });
        }

        if (E && (0, _isObject2.default)(E.Ajax)) {
            E.Ajax.defaultHeaders = headers;
        }
    }
};

AppManager.prototype.applyTo = function (modules) {
    var t = this;

    (0, _arrayTo2.default)(modules).forEach(function (module) {
        module.appManager = t;
    });
};

// dep 1

AppManager.prototype.getApiPath = function () {
    var t = this;

    var version = t.getApiVersion() || '';

    return t.getPath() + '/api' + (version ? '/' + version : '');
};

AppManager.prototype.getLegendColorByValue = function (id, value) {
    var t = this,
        color;

    var legendSet = t.getLegendSetById(id);

    for (var i = 0, legend; i < legendSet.legends.length; i++) {
        legend = legendSet.legends[i];

        if (value >= parseFloat(legend.startValue) && value < parseFloat(legend.endValue)) {
            color = legend.color;
            break;
        }
    }

    return color;
};

AppManager.prototype.getDisplayPropertyUrl = function () {
    if (this.displayPropertyUrl) {
        return this.displayPropertyUrl;
    }

    var key = this.getDisplayProperty();

    return this.displayPropertyUrl = key + '~rename(name)';
};

AppManager.prototype.isUiLocaleDefault = function () {
    return this.getUiLocale() === this.defaultUiLocale;
};

AppManager.prototype.getAnalysisFields = function () {
    return this.analysisFields ? this.analysisFields : this.analysisFields = (0, _stringReplaceAll2.default)(this.defaultAnalysisFields.join(','), '$', this.getDisplayPropertyUrl());
};

AppManager.prototype.getRootNode = function () {
    return this.getRootNodes()[0];
};

// dep 2

AppManager.prototype.getLegendSetIdByDxId = function (id, fn) {
    if (!((0, _isString2.default)(id) && (0, _isFunction2.default)(fn))) {
        return;
    }

    var t = this;

    var legendSetId;

    new t.refs.api.Request(t.refs, {
        type: 'json',
        baseUrl: t.getApiPath() + '/indicators.json',
        params: ['filter=id:eq:' + id, 'fields=legendSet[id]', 'paging=false'],
        success: function success(json) {
            if ((0, _isArray2.default)(json.indicators) && json.indicators.length) {
                if ((0, _isObject2.default)(json.indicators[0].legendSet)) {
                    var legendSet = json.indicators[0].legendSet;

                    if ((0, _isObject2.default)(legendSet)) {
                        legendSetId = legendSet.id;
                    }
                }
            }
        },
        complete: function complete() {
            fn(legendSetId);
        }
    }).run();
};

AppManager.prototype.getOptionSets = function (response, callbackFn) {
    var optionSetHeaders = response.getOptionSetHeaders();
    var dhis2 = window.dhis2;

    if (optionSetHeaders.length) {
        var callbacks = 0,
            optionMap = {};

        var fn = function fn() {
            if (++callbacks === optionSetHeaders.length) {
                response.metaData.optionNames = optionMap;
                callbackFn();
            }
        };

        var getObjectMap = function getObjectMap(array) {
            var idProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
            var nameProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';
            var namePrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

            if (!((0, _isArray2.default)(array) && array.length)) {
                return {};
            }

            var map = {};

            array.forEach(function (obj) {
                map[namePrefix + obj[idProperty]] = obj[nameProperty];
            });

            return map;
        };

        var getOptions = function getOptions(optionSetId, dataElementId) {
            dhis2.er.store.get('optionSets', optionSetId).done(function (obj) {
                _extends(optionMap, getObjectMap(obj.options, 'code', 'name', dataElementId));
                fn();
            });
        };

        // execute
        optionSetHeaders.forEach(function (header) {
            var optionSetIds = (0, _arrayFrom2.default)(header.optionSet);
            var dataElementId = header.name;

            optionSetIds.forEach(function (id) {
                getOptions(id, dataElementId);
            });
        });
    } else {
        callbackFn();
    }
};
//# sourceMappingURL=AppManager.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/manager/AppManager.js
 ** module id = 141
 ** module chunks = 0 1
 **/